import type { ReactNode } from 'react';
import styles from './KeyValue.module.css';

export interface KeyValueItem {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

export interface KeyValueProps {
  /** Rows with empty values are left out (docs/ux-richtlinien.md §6.8). */
  items: KeyValueItem[];
}

const isEmpty = (v: ReactNode) => v === null || v === undefined || v === '' || v === false;

/** "Label … value" rows, e.g. the facts on a detail page. */
export function KeyValue({ items }: KeyValueProps) {
  const shown = items.filter((i) => !isEmpty(i.value));
  if (shown.length === 0) return null;
  return (
    <dl className={styles.list}>
      {shown.map((i) => (
        <div key={i.key} className={styles.row}>
          <dt className={styles.label}>{i.label}</dt>
          <dd className={styles.value}>{i.value}</dd>
        </div>
      ))}
    </dl>
  );
}
